import { FiX } from 'react-icons/fi';
import { useDropzone } from 'react-dropzone';
import { useSingleFileDrop } from 'hooks/useSingleFileDrop';

interface FileUploadProps {
  label: string;
  name: string;
  formik: any;
  description?: string;
  removeDocument: (type: any) => void;
  maxSizeLabel?: string; // e.g. "5MB"
}

const CustomFileUpload: React.FC<FileUploadProps> = ({
  label,
  description,
  name,
  formik,
  removeDocument,
  maxSizeLabel = '5MB',
}) => {
  // REUSABLE HOOK LOGIC INTEGRATED
  const onDrop = useSingleFileDrop(formik, {
    fieldName: name,
    maxSizeMB: Number(maxSizeLabel.replace('MB', '')),
    singleFileError: `You can only upload one ${label}.`,
    sizeError: `${label} must not exceed ${maxSizeLabel}.`,
  });

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': [], // all image types
      'application/pdf': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        [], // .docx
    },
  });

  return (
    <div className="col-span-1">
      <p>
        {label} {description && <p className="text-[10px]">{description}</p>}
      </p>

      <div className="mt-0.5 flex items-center justify-center flex-col border rounded-md p-3">
        <div
          {...getRootProps()}
          className="flex items-center justify-center flex-col cursor-pointer"
        >
          <input {...getInputProps()} />
          <img src="/Assets/upload.svg" className="w-12" alt="upload" />

          <p>
            <span className="text-blue-500 font-medium">Click to upload</span>{' '}
            or drag and drop
          </p>

          <p className="text-xs">.jpeg or .pdf (max. {maxSizeLabel})</p>

          {formik.errors[name] && (
            <div className="text-red-500 text-xs text-center">
              {formik.errors[name] as string}
            </div>
          )}
        </div>

        {formik.values[name] && (
          <ul className="mt-2">
            <li className="flex justify-between items-center">
              <span>{formik.values[name]?.name}</span>

              <button
                type="button"
                onClick={() => removeDocument(name)}
                className="text-red-500"
              >
                <FiX />
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default CustomFileUpload;
